import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { Inbox, Loader2, Clock, UserCheck, CheckCircle2, Landmark, ShieldCheck } from "lucide-react";
import { api } from "../lib/api";

export default function AdminDashboard() {
  const [stats, setStats] = useState(null);

  useEffect(() => {
    api.get("/admin/stats").then((r) => setStats(r.data)).catch(() => setStats({}));
  }, []);

  const cards = [
    { key: "aperte", label: "Richieste aperte", icon: Inbox, color: "#2563EB" },
    { key: "in_lavorazione", label: "In lavorazione", icon: Loader2, color: "#D97706" },
    { key: "attesa_cliente", label: "In attesa cliente", icon: Clock, color: "#EA580C" },
    { key: "chiuse", label: "Chiuse", icon: CheckCircle2, color: "#64748B" },
    { key: "credito", label: "Credito", icon: Landmark, color: "#0A192F" },
    { key: "assicurazioni", label: "Assicurazioni", icon: ShieldCheck, color: "#F97316" },
  ];

  return (
    <div data-testid="admin-dashboard-page" className="space-y-8">
      <div>
        <h1 className="font-display text-3xl font-bold text-[#0A192F]">Dashboard Back Office</h1>
        <p className="mt-1 text-slate-600">Panoramica delle richieste dei clienti ViviTranquillo.</p>
      </div>

      {stats === null ? (
        <div className="py-20 text-center text-slate-400">Caricamento...</div>
      ) : (
        <div className="grid gap-5 sm:grid-cols-2 lg:grid-cols-3">
          {cards.map((c) => (
            <div key={c.key} data-testid={`admin-kpi-${c.key}`} className="rounded-2xl border border-slate-200 bg-white p-6">
              <div className="flex items-center justify-between">
                <span className="flex h-11 w-11 items-center justify-center rounded-xl" style={{ backgroundColor: `${c.color}1a` }}>
                  <c.icon className="h-5 w-5" style={{ color: c.color }} />
                </span>
                <span className="font-display text-3xl font-extrabold text-[#0A192F]">{stats[c.key] ?? 0}</span>
              </div>
              <p className="mt-4 text-sm font-semibold text-slate-600">{c.label}</p>
            </div>
          ))}
        </div>
      )}

      <Link to="/admin/richieste" data-testid="admin-dashboard-to-requests" className="inline-flex items-center gap-2 rounded-full bg-[#10B981] px-7 py-3 font-semibold text-white transition-colors hover:bg-[#059669]">
        <Inbox className="h-4 w-4" /> Vai all'elenco richieste
      </Link>
    </div>
  );
}
